<div class="circle-wrap" [ngClass]="{'mob': isMobile}">
  <div class="circle">
    <div class="mask full">
      <div class="fill"></div>
    </div>
    <div class="mask half">
      <div class="fill"></div>
    </div>
    <div class="inside-circle">
      <span class="bold" *ngIf="!isMobile">{{step}}</span>
      <span class="page-count bold" *ngIf="isMobile">{{step}}/4</span>
      <ng-container *ngIf="showPercentage">{{ targetPercentage }}%</ng-container>
    </div>
  </div>
</div>